let company = [{
		// 深圳
		name: 'szyoupudao.com',
		subdoadmin: 'sz'
	},
	{
		// 天津
		name: 'tjyoupudao.com',
		subdoadmin: 'tj'
	},
	{
		// 江西
		name: 'jxyoupudao.com',
		subdoadmin: 'jx'
	},
	{
		// 重庆
		name: 'cqyoupudao.com',
		subdoadmin: 'cq'
	},
	{
		// 广西
		name: 'gxyoupudao.com',
		subdoadmin: 'gx'
	},
	{
		// 海南
		name: 'youpudaohn.com',
		subdoadmin: 'hn'
	},
	{
		// 四川
		name: 'scyoupudao.com',
		subdoadmin: 'sc'
	},
	{
		// 浙江
		name: 'zjyoupudao.com',
		subdoadmin: 'zj'
	},
	{
		// 北京
		name: 'bjyoupudao.com',
		subdoadmin: 'bj'
	},
	{
		// 内蒙古
		name: 'nmgyoupudao.com',
		subdoadmin: 'nmg'
	},
	{
		// 吉林
		name: 'jlypd.com',
		subdoadmin: 'jl'
	},
	{
		// 青海
		name: 'qhyoupudao.com',
		subdoadmin: 'qh'
	},
	{
		// 上海
		name: 'shyoupudao.com',
		subdoadmin: 'sh'
	},
	{
		// 河南
		name: 'hnyoupudao.com',
		subdoadmin: 'hn1'
	},
	{
		// 江苏
		name: 'jsyoupudao.com',
		subdoadmin: 'js'
	},
	{
		// 贵州
		name: 'gzyoupudao.com',
		subdoadmin: 'gz'
	},
	{
		// 陕西
		name: 'sxyoupudao.com',
		subdoadmin: 'sx1'
	},
	{
		// 黑龙江
		name: 'hljyoupudao.com',
		subdoadmin: 'hlj'
	},
	{
		// 山西
		name: 'youpudaosx.com',
		subdoadmin: 'sx'
	},
	{
		// 甘肃
		name: 'gsyoupudao.com',
		subdoadmin: 'gs'
	},
	{
		//辽宁
		name: 'lnyoupudao.com',
		subdoadmin: 'ln'
	},
	{
		//福建
		name: 'fjyoupudao.com',
		subdoadmin: 'fj'
	},
]


export const host = 'http://sadmin.youpudao.com/api'; //正式线 
// export const host = 'http://192.168.18.78:8090/api'; //正式线
export const devHost = 'http://company.maolvxiansheng.top'; // 测试线
let url = window.location.hostname;
// let url = 'tjyoupudao.com';

if (url.indexOf('www.') != -1) {
	var reg = new RegExp("www.");
	url = url.replace(reg, "");
}

let c = 'sz';
let setwww = '';
let development = process.env.NODE_ENV == 'development' ? true : false;
if (!development) {
	let hadCompany = company.filter(item => {
		return url.indexOf(item.name) !== -1
	})
	if (hadCompany.length == 0) {
		let str = url.split('.')[0];
		c = str == 'youpudao' ? 'www' : str;
		setwww = 'www';
	} else {
		c = hadCompany[0].subdoadmin
	}
}
export const setw = setwww
export const subdoadmin = c